import { AsyncDataProvider } from 'modules/data-providers';
import { useSelector } from 'modules/react-redux';
import { useCallback } from 'react';
import { GetNetSuiteDictionariesTaxCodes, useLazyGetNetSuiteDictionariesTaxCodes } from 'shared/data/webApp/v1';

import { getRequest } from '../../../../selectors/pageSelectors';
import { NetSuiteSubsidiaryTaxCodesDataProviderProps } from './NetSuiteSubsidiaryTaxCodesDataProvider.types';

export const NetSuiteSubsidiaryTaxCodesDataProvider = (props: NetSuiteSubsidiaryTaxCodesDataProviderProps) => {
    const { subsidiaryId, children } = props;

    const request = useSelector(getRequest);

    const { companyId } = request;

    const [triggerGetNetSuiteDictionariesTaxCodes] = useLazyGetNetSuiteDictionariesTaxCodes();

    const onLoad = useCallback(
        async (filterText: string | null) => {
            if (!subsidiaryId) {
                return [];
            }

            try {
                const query: GetNetSuiteDictionariesTaxCodes['params']['query'] = {
                    companyId,
                };

                if (subsidiaryId) {
                    query.subsidiaryId = subsidiaryId;
                }

                if (filterText) {
                    query.query = filterText;
                }

                const response = await triggerGetNetSuiteDictionariesTaxCodes({
                    params: { query },
                });

                return response.values.map((taxCode) => ({
                    id: taxCode.id,
                    text: taxCode.name,
                }));
            } catch {
                return [];
            }
        },
        [companyId, subsidiaryId, triggerGetNetSuiteDictionariesTaxCodes]
    );

    return (
        <AsyncDataProvider
            cacheStorageId={`requestOptions.netSuiteTaxCodes.${companyId}.${subsidiaryId}`}
            pageSize={100}
            onLoad={onLoad}
        >
            {children}
        </AsyncDataProvider>
    );
};

NetSuiteSubsidiaryTaxCodesDataProvider.displayName = 'NetSuiteSubsidiaryTaxCodesDataProvider';
